import { createSlice } from '@reduxjs/toolkit';

// Savat — faqat shu brauzerda saqlanadi (localStorage), narx server tomonidan
// buyurtma yuborilganda QAYTA hisoblanadi (bu yerdagi narx faqat ko'rsatish
// uchun, ishonch uchun emas). Bitta mahsulot BIR NECHTA birlikda (dona/pachka/
// karobka) alohida qatorda bo'lishi mumkin — sotuv agenti katalogidagi kabi —
// shuning uchun qator kaliti productId EMAS, productId+unitKey juftligi.
const STORAGE_KEY = 'client_cart';

function loadCart() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const items = raw ? JSON.parse(raw) : [];
    return Array.isArray(items) ? items : [];
  } catch {
    return [];
  }
}

function saveCart(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch {
    // localStorage bo'lmasa ham (private rejim) ilova ishlashda davom etadi
  }
}

const sameLine = (i, productId, unitKey) => i.productId === productId && i.unitKey === unitKey;

const cartSlice = createSlice({
  name: 'cart',
  initialState: { items: loadCart() },
  reducers: {
    // Bitta (mahsulot, birlik) qatorini qat'iy qiymatga o'rnatadi — qty<=0
    // bo'lsa qator olib tashlanadi. Birlik almashtirilganda alohida qator
    // yaratiladi (masalan "5 karobka" va "3 pachka" bir vaqtda savatda turadi).
    setLine: (state, action) => {
      const { productId, unitKey, unitLabel, name, image, price, currency, qty } = action.payload;
      const idx = state.items.findIndex(i => sameLine(i, productId, unitKey));
      if (qty <= 0) {
        if (idx !== -1) state.items.splice(idx, 1);
      } else if (idx !== -1) {
        state.items[idx].qty = qty;
      } else {
        state.items.push({ productId, unitKey, unitLabel, name, image, price, currency, qty });
      }
      saveCart(state.items);
    },
    removeLine: (state, action) => {
      const { productId, unitKey } = action.payload;
      state.items = state.items.filter(i => !sameLine(i, productId, unitKey));
      saveCart(state.items);
    },
    clearCart: (state) => {
      state.items = [];
      saveCart(state.items);
    },
  },
});

export const { setLine, removeLine, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
